<template>
  <div>
    <div
      v-for="layer in layers"
      :key="layer.zone"
      class="covering-zone-band"
      :style="bandStyle(layer)"
    />
    <CoveringZoneBadge
      v-for="layer in layers"
      :key="`${layer.zone}-label`"
      :zone="layer.zone"
      on-media
      class="covering-zone-chip"
      :style="chipStyle(layer)"
    />
  </div>
</template>

<script>
  import { irFrameZoneOverlayLayers } from '@/features/defect-drawer/utils/resolveModuleCoveringIrImages';
  import CoveringZoneBadge from '@/features/defect/components/CoveringZoneBadge.vue';

  const ZONE_FILL = {
    zone1: 'rgba(16, 185, 129, 0.38)',
    zone2: 'rgba(14, 165, 233, 0.32)',
    zone3: 'rgba(245, 158, 11, 0.28)'
  };
  const ZONE_BORDER = {
    zone1: '#34d399',
    zone2: '#38bdf8',
    zone3: '#fbbf24'
  };

  export default {
    name: 'DefectCoveringZoneOverlay',
    components: { CoveringZoneBadge },
    props: {
      imageToScreen: { type: Function, default: null },
      imageWidth: { type: Number, default: 640 },
      imageHeight: { type: Number, default: 512 },
      showZones: { type: Boolean, default: true }
    },
    computed: {
      layers() {
        if (!this.showZones) {
          return [];
        }
        return irFrameZoneOverlayLayers(this.imageWidth, this.imageHeight);
      }
    },
    methods: {
      mapPoint(x, y) {
        if (typeof this.imageToScreen === 'function') {
          return this.imageToScreen(x, y);
        }
        return { x, y };
      },
      bandStyle(layer) {
        const topLeft = this.mapPoint(layer.x, layer.y);
        const botRight = this.mapPoint(layer.x + layer.w, layer.y + layer.h);
        return {
          left: `${topLeft.x}px`,
          top: `${topLeft.y}px`,
          width: `${Math.max(0, botRight.x - topLeft.x)}px`,
          height: `${Math.max(0, botRight.y - topLeft.y)}px`,
          backgroundColor: ZONE_FILL[layer.zone],
          borderColor: ZONE_BORDER[layer.zone]
        };
      },
      chipStyle(layer) {
        const point = this.mapPoint(layer.labelX, layer.labelY);
        return {
          left: `${point.x}px`,
          top: `${point.y}px`
        };
      }
    }
  };
</script>

<style scoped>
  .covering-zone-band {
    position: absolute;
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
  }

  .covering-zone-chip {
    position: absolute;
    z-index: 3;
    max-width: none;
    overflow: visible;
    white-space: nowrap;
    transform: translate(-50%, -50%);
  }

  .covering-zone-chip >>> .v-chip__content {
    white-space: nowrap;
    overflow: visible;
  }
</style>
